import type { FetchResponse } from 'openapi-fetch';
import type { paths } from './coreApiSchema';
import { getItem } from '../utils/storage';
import { getLegacyMeetingRooms } from './legacyMeetingRooms';
import { shouldUseCoreApi } from '../utils/features';
import { coreApiClient } from './apiClient';
import { API_VERSION } from '../config/app';
export const getMeetingRooms = async ({
  tenantId,
  limit,
  offset,
}: {
  tenantId: number;
  limit?: number;
  offset?: number;
}): Promise<
  FetchResponse<paths['/core/v1/meeting-rooms']['get'], { parseAs: 'json' }, 'application/json'>
> => {
  if (!shouldUseCoreApi()) {
    return getLegacyMeetingRooms();
  }

  return coreApiClient.GET('/core/v1/meeting-rooms', {
    params: {
      query: {
        status: 'active',
        limit,
        offset,
      },
      header: {
        authorization: `Bearer ${getItem('coreApiAccessToken')}`,
        'cosafe-api-version': String(API_VERSION),
        'cosafe-tenant-id': String(tenantId),
      },
    },
  });
};
